import { Component, inject, OnInit } from '@angular/core';
import { DataStorageService } from '../../services/data-storage.service';
import { ThankYouOwner } from '../../models/thank-you-owner.model';

/**
 * Component that displays a thank you message after successful application submission
 * Shows user details and a button to return to the home page
 */
@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrl: './thank-you.component.scss'
})
export class ThankYouComponent implements OnInit {
  private readonly dataStorageService = inject(DataStorageService);
  
  public firstOwner!: ThankYouOwner;

  public ngOnInit(): void {
    const personalDetails = this.dataStorageService.getItem<any>('personalDetailsForm');
    
    this.firstOwner = {
      firstName: personalDetails.firstName,
      lastName: personalDetails.lastName,
      emailAddress: personalDetails.emailAddress
    };

    // Clear all application data after loading the thank you page
    this.clearApplicationCache();
  }

  /**
   * Clear all application data from storage
   */
  private clearApplicationCache(): void {
    // Clear all session storage data
    sessionStorage.clear();
  }
}
